<template>
    <b-container class="not-found">
        <div>
            <h1>404</h1>
            <h3>Page not found</h3> 
        </div>
    </b-container>
</template>
<script>
    export default {
        name: 'PageNotFound'
    }
</script>
<style>
    .not-found{
        margin-top: 50px;
    }
</style>